import * as types from './types';
import * as functions from './functions';

export const parseAppiumLog = (logFile) => ({
  type: types.PARSE_APPIUM_JOB,
  payload: functions.parseAppiumLog(logFile),
});

export const parseSeleniumLog = (logFile) => ({
  type: types.PARSE_SELENIUM_JOB,
  payload: functions.parseSeleniumLog(logFile),
});
